export const initialSeoState = {
  loading: false,
  error: null,
  dataSeo: null,
};
